import gql from 'graphql-tag'

export const fetchProductsQuery = gql`
  query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_id: [String]
    $category_uid: [String]
    $filter_packaging: [String]
    $packaging: [String]
    $sub_brand: [String]
    $volume: [String]
    $pack_format: [String]
    $country_of_origin: [String]
    $currentPage: Int!
    $pageSize: Int = 25
    $is_peroni: Boolean = false
    $product_last: String
    $product_new: String
    $product_sale: String
    $product_seasonal: String
    $product_recommended: String
    $product_type: String
  ) {
    products(
      search: $search
      filter: {
        sku: { in: $sku }
        type_id: {eq: $product_type}
        brand: { in: $brand }
        sub_brand: { in: $sub_brand }
        category_id: { in: $category_id }
        category_uid: { in: $category_uid }
        pack_format: { in: $pack_format }
        country_of_origin: { in: $country_of_origin }
        filter_packaging: { in: $filter_packaging }
        packaging: { in: $packaging }
        volume: { in: $volume }
        product_last: { eq: $product_last }
        product_new: { eq: $product_new }
        product_sale: { eq: $product_sale }
        product_seasonal: { eq: $product_seasonal }
        product_recommended: { eq: $product_recommended }
      }
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      total_count
      aggregations {
        attribute_code
        count
        label
        options {
          label
          value
          count
        }
      }
      items {
        high_markets_discount
        saleability{
          disabled_from
          disabled_to
          sellable
        }
        multi_deposit
        material_type
        number_of_items_in_box
        name
        catalog_product_name
        deliveryDate
        sku
        your_price
        your_price_tax
        product_reco_tags {
          value
          label
          color
        }
        favourites
        promo
        product_last
        product_new
        product_sale
        product_seasonal
        product_recommended
        packaging_enable
        number_of_bottles_gabbie
        number_of_products_on_layer
        number_of_items_on_pallet
        number_of_layers_per_pallet
        volume
        description {
          html
        }
        features @include(if: $is_peroni) {
          fermentation
          beer_type
          province
          taste
          custom_color
          alcohol_content
          food_pairing
          conservation_term
          service_temperature
        }
        small_image {
          url
        }
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
        }
      }
      page_info {
        page_size
        total_pages
        current_page
      }
      categoryFilter{
        category_id
        category_uid
        category_name
      }
    }
  }
`
